import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import style from "css/template.module.css";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import MobileMenuItem from "./mobile/mobileMenuItem";
import MobileSmartSpace from "./mobile/mobileSmartSpace";
import MobileSmartDevice from "./mobile/mobileSmartDevice";
import MobileSmartSolution from "./mobile/mobileSmartSolution";
import axios from "axios";
import { sendEvent } from "analytics/ga4";

/**
 * Version : 1.0
 * 작성일자 : 2023-12-11
 * 작성자 : 권도훈
 * 설명 : 공통 템플릿 영역
 */
function Header() {
  const { pathname } = useLocation();
  const path = process.env.NODE_ENV === "production" ? "/riv" : "/";
  //payload
  const payload = useSelector((state) => state.scroll);
  const [scrollHeader, setScrollHeader] = useState(false);

  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const [openMenuType, setOpenMenuType] = useState("");

  // scroll 위치가 100이하라면 투명한 배경색을 지정하고, 아니면 흰색을 지정한다.
  useEffect(() => {
    if (payload.scrollPosition < 100) {
      setScrollHeader(false);
    } else {
      setScrollHeader(true);
    }
  }, [payload.scrollPosition]);

  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [menuType, setMenuType] = useState("");

  //PC 상단 헤더 클릭 이벤트
  const handleMenuClick = (type) => {
    if (type === menuType && isOpenMenu) {
      // setMenuType("");
      setIsOpenMenu(false);
    } else {
      setMenuType(type);
      setIsOpenMenu(true);
    }
  };

  //모바일 메뉴 버튼 클릭 이벤트
  const handleMobileMenuOpen = () => {
    if (isOpenMenu) {
      setIsOpenMenu(false);
    } else {
      setIsOpenMenu(true);
    }
  };

  const handleDownloadIntroduction = () => {
    sendEvent("Download", "click_download", "company_introduction");
    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_CLIENT_URL}docs/Introduction_riv_technology.pdf`;
    link.download = "Introduction of Riv Technology_회사소개서.pdf"; // 저장될 파일명
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const menuSwitch = (type) => {
    switch (type) {
      case "space":
        return (
          <div className={`${style.sub_header_container} ${style.space}`}>
            <div className={style.sub_header_space_list}>
              <div className={style.sub_header_space_list_item}>
                <Link
                  to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work`}
>
                  <div className={style.sub_header_space_main_nav}>
                    <span>스마트 워크 스페이스</span>
                    <img
                      alt="work-space"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/header/arrow_right.png`}
                    />
                  </div>
                </Link>
                <div className={style.sub_header_space_menu_list}>
                  <Link
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/reception`}
                  >
                    <div className={style.sub_header_space_menu_item}>
                      <div className={style.sub_header_space_menu_icon_wrap}>
                        <img
                          alt="reception"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/reception.png`}
                        />
                      </div>
                      <span>가상 리셉셔니스트</span>
                    </div>
                  </Link>
                  <Link
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/hotdesk`}
                  >
                    <div className={style.sub_header_space_menu_item}>
                      <div className={style.sub_header_space_menu_icon_wrap}>
                        <img
                          alt="hotdesk"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/hotdesk.png`}
                        />
                      </div>
                      <span>자율좌석제</span>
                    </div>
                  </Link>
                  <Link
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/conference`}
                  >
                    <div className={style.sub_header_space_menu_item}>
                      <div className={style.sub_header_space_menu_icon_wrap}>
                        <img
                          alt="conference"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/conference.png`}
                        />
                      </div>
                      <span>회의실 예약 시스템</span>
                    </div>
                  </Link>
                  <Link
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/videoconference`}
                  >
                    <div className={style.sub_header_space_menu_item}>
                      <div className={style.sub_header_space_menu_icon_wrap}>
                        <img
                          alt="videoconference"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/videoconference.png`}
                        />
                      </div>
                      <span>화상회의 시스템</span>
                    </div>
                  </Link>
                </div>
              </div>
              <div className={style.sub_header_space_list_item}>
                <Link
                  to={`${process.env.REACT_APP_CLIENT_URL}smart-space/room`}
>
                  <div className={style.sub_header_space_main_nav}>
                    <span>스마트 강의실/교실</span>
                    <img
                      alt="room"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/header/arrow_right.png`}
                    />
                  </div>
                </Link>
                <div className={style.sub_header_space_menu_list}>
                  <Link
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-space/room/classRoom`}
                  >
                    <div className={style.sub_header_space_menu_item}>
                      <div className={style.sub_header_space_menu_icon_wrap}>
                        <img
                          alt="classRoom"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/classRoom.png`}
                        />
                      </div>
                      <span>하이브리드 스마트 강의실</span>
                    </div>
                  </Link>
                  <Link
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-space/room/group`}
                  >
                    <div className={style.sub_header_space_menu_item}>
                      <div className={style.sub_header_space_menu_icon_wrap}>
                        <img
                          alt="group"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/group.png`}
                        />
                      </div>
                      <span>하이브리드 그룹 강의실</span>
                    </div>
                  </Link>
                  <Link
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-space/room/lab`}
                  >
                    <div className={style.sub_header_space_menu_item}>
                      <div className={style.sub_header_space_menu_icon_wrap}>
                        <img
                          alt="lab"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/lab.png`}
                        />
                      </div>
                      <span>하이브리드 스마트 실습실</span>
                    </div>
                  </Link>
                  <Link
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-space/room/laboratory`}
                  >
                    <div className={style.sub_header_space_menu_item}>
                      <div className={style.sub_header_space_menu_icon_wrap}>
                        <img
                          alt="laboratory"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/laboratory.png`}
                        />
                      </div>
                      <span>하이브리드 연구실/교수실</span>
                    </div>
                  </Link>
                </div>
              </div>
              <div className={style.sub_header_space_list_item}>
                {/* <div className={style.disabled_menu_bg}>
                  <article className={style.disabled_menu_article}>
                    <p>곧 공개 예정</p>
                    <p>새로운 페이지가 곧 찾아옵니다.</p>
                  </article>
                </div> */}

                <Link
                  to={`${process.env.REACT_APP_CLIENT_URL}smart-space/telehealth`}
>
                  <div className={style.sub_header_space_main_nav}>
                    <span>스마트 텔레헬스 시스템</span>
                    <img
                      alt="telehealth"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/header/arrow_right.png`}
                    />
                  </div>
                </Link>
                <div className={style.sub_header_space_menu_list}>
                  <Link
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-space/telehealth/telehealth`}
                  >
                    <div className={style.sub_header_space_menu_item}>
                      <div className={style.sub_header_space_menu_icon_wrap}>
                        <img
                          alt="telehealth"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/telehealth.png`}
                        />
                      </div>
                      <span>원격 진료</span>
                    </div>
                  </Link>
                  <Link
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-space/telehealth/telerounding`}
                  >
                    <div className={style.sub_header_space_menu_item}>
                      <div className={style.sub_header_space_menu_icon_wrap}>
                        <img
                          alt="telerounding"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/telerounding.png`}
                        />
                      </div>
                      <span>원격 회진</span>
                    </div>
                  </Link>
                  <Link
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-space/telehealth/telecollaboration`}
                  >
                    <div className={style.sub_header_space_menu_item}>
                      <div className={style.sub_header_space_menu_icon_wrap}>
                        <img
                          alt="telecollaboration"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/telecollaboration.png`}
                        />
                      </div>
                      <span>원격 협진</span>
                    </div>
                  </Link>
                  <Link
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-space/telehealth/symposium`}
                  >
                    <div className={style.sub_header_space_menu_item}>
                      <div className={style.sub_header_space_menu_icon_wrap}>
                        <img
                          alt="symposium"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/symposium.png`}
                        />
                      </div>
                      <span>의료세미나/학술대회</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <span />
            <div className={style.sub_header_space_size_group}>
              <div className={style.sub_header_space_size_group_title}>
                규모별 공간 구성
              </div>
              <div className={style.sub_header_space_vc_size_list}>
                <Link
                  to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/videoconference/individual`}
                  state={{ status: "individual" }}
                >
                  <div className={style.sub_header_space_vc_size_item}>
                    <span>1인 / 개인 사무실</span>
                    <img
                      alt="right"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/header/right.png`}
                    />
                  </div>
                </Link>
                <Link
                  to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/videoconference/small`}
                  state={{ status: "small" }}
                >
                  <div className={style.sub_header_space_vc_size_item}>
                    <span>중소형 회의실</span>
                    <img
                      alt="right"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/header/right.png`}
                    />
                  </div>
                </Link>
                <Link
                  to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/videoconference/large`}
                  state={{ status: "large" }}
                >
                  <div className={style.sub_header_space_vc_size_item}>
                    <span>대형 회의실</span>
                    <img
                      alt="right"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/header/right.png`}
                    />
                  </div>
                </Link>
                <Link
                  to={`${process.env.REACT_APP_CLIENT_URL}smart-space/work/videoconference/lounge`}
                  state={{ status: "lounge" }}
                >
                  <div className={style.sub_header_space_vc_size_item}>
                    <span>공용라운지 및 오피스</span>
                    <img
                      alt="right"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/header/right.png`}
                    />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        );
      case "device":
        return (
          <div className={`${style.sub_header_container} ${style.device}`}>
            <div className={style.sub_header_device_column_group}>
              <Link
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/bar2`}
>
                <div className={style.sub_header_device_item}>
                  <span className={style.sub_header_device_item_title}>
                    neat.bar Generation2
                  </span>
                  <img
                    alt="bar2"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/neat_bar_2.png`}
                  />
                </div>
              </Link>
              <Link
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/barPro`}
>
                <div className={style.sub_header_device_item}>
                  <span className={style.sub_header_device_item_title}>
                    neat.bar pro
                  </span>
                  <img
                    alt="bar pro"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/neat_bar_pro.png`}
                  />
                </div>
              </Link>
            </div>
            <div className={style.sub_header_device_row_group}>
              <Link
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/boardPro`}
>
                <div className={style.sub_header_device_item}>
                  <span className={style.sub_header_device_item_title}>
                    neat.board pro
                  </span>
                  <img
                    alt="board pro"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/neat_board_pro.png`}
                  />
                </div>
              </Link>
              <Link
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/board50`}
>
                <div className={style.sub_header_device_item}>
                  <span className={style.sub_header_device_item_title}>
                    neat.board 50
                  </span>
                  <img
                    alt="board 50"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/neat_board_50.png`}
                  />
                </div>
              </Link>
              <Link
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/frame`}
>
                <div className={style.sub_header_device_item}>
                  <span className={style.sub_header_device_item_title}>
                    neat.frame
                  </span>
                  <img
                    alt="frame"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/neat_frame.png`}
                  />
                </div>
              </Link>
              <Link
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/center`}
>
                <div className={style.sub_header_device_item}>
                  <span className={style.sub_header_device_item_title}>
                    neat.center
                  </span>
                  <img
                    alt="center"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/neat_center.png`}
                  />
                </div>
              </Link>
              <Link
                to={`${process.env.REACT_APP_CLIENT_URL}smart-device/neat/pad`}
>
                <div className={style.sub_header_device_item}>
                  <span className={style.sub_header_device_item_title}>
                    neat.pad
                  </span>
                  <img
                    alt="pad"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/neat_pad.png`}
                  />
                </div>
              </Link>
            </div>
          </div>
        );
      case "solution":
        return (
          <div className={`${style.sub_header_container} ${style.solution}`}>
            <Link
              to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/allplace`}
>
              <div className={style.sub_header_solution_item}>
                <div
                  className={style.sub_header_solution_logo_wrap}
                  style={{ borderColor: "#000" }}
                >
                  <img
                    alt="all_place"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/all_place.png`}
                  />
                </div>
                <div className={style.sub_header_solution_info}>
                  <div className={style.sub_header_solution_title}>
                    all Place
                  </div>
                  <div className={style.sub_header_solution_desc}>
                    하이브리드 워크를 위한 스마트 공간 예약 플랫폼
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/begate`}
>
              <div className={style.sub_header_solution_item}>
                <div
                  className={style.sub_header_solution_logo_wrap}
                  style={{ borderColor: "#fe9d12" }}
                >
                  <img
                    alt="be_gate"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/be_gate.png`}
                  />
                </div>
                <div className={style.sub_header_solution_info}>
                  <div className={style.sub_header_solution_title}>Be Gate</div>
                  <div className={style.sub_header_solution_desc}>
                    클라우드 화상회의와 사내시스템을 연결하는 최적의 솔루션
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/privateConnectManager`}
>
              <div className={style.sub_header_solution_item}>
                <div
                  className={style.sub_header_solution_logo_wrap}
                  style={{ borderColor: "#eb5838" }}
                >
                  <img
                    alt="private_connect_manager"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/private_connect_manager.png`}
                  />
                </div>
                <div className={style.sub_header_solution_info}>
                  <div className={style.sub_header_solution_title}>
                    Private Connect Manager
                  </div>
                  <div className={style.sub_header_solution_desc}>
                    Private Connect의 운용/관리를 위한 관리자 전용 시스템
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/cmsmanager`}
>
              <div className={style.sub_header_solution_item}>
                <div
                  className={style.sub_header_solution_logo_wrap}
                  style={{ borderColor: "#1e9ce4" }}
                >
                  <img
                    alt="cms_manager"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/cms_manager.png`}
                  />
                </div>
                <div className={style.sub_header_solution_info}>
                  <div className={style.sub_header_solution_title}>
                    CMS Manager
                  </div>
                  <div className={style.sub_header_solution_desc}>
                    Cisco Meeting Server의 운용/관리를 위한 관리자 전용 시스템
                  </div>
                </div>
              </div>
            </Link>

            <Link
              to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/deviceOne`}
>
              <div className={style.sub_header_solution_item}>
                <div
                  className={style.sub_header_solution_logo_wrap}
                  style={{ borderColor: "#5464f5" }}
                >
                  <img
                    alt="device_one"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/device_one.png`}
                  />
                </div>
                <div className={style.sub_header_solution_info}>
                  <div className={style.sub_header_solution_title}>
                    DeviceOne
                  </div>
                  <div className={style.sub_header_solution_desc}>
                    강의실 neat 디바이스 컨트롤 및 관리 시스템
                  </div>
                </div>
              </div>
            </Link>
            <Link
              to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/medilink`}
>
              <div className={style.sub_header_solution_item}>
                <div
                  className={style.sub_header_solution_logo_wrap}
                  style={{ borderColor: "#022759" }}
                >
                  <img
                    alt="medi_link"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/header/medi_link.png`}
                  />
                </div>
                <div className={style.sub_header_solution_info}>
                  <div className={style.sub_header_solution_title}>
                    MediLink
                  </div>
                  <div className={style.sub_header_solution_desc}>
                    원격 협진을 위한 안전한 비대면 진료 플랫폼
                  </div>
                </div>
              </div>
            </Link>
          </div>
        );
      default:
        return <></>;
    }
  };

  useEffect(() => {
    if (isOpenMenu) {
      // setMenuType("");
      setIsOpenMenu(false);
    }
  }, [pathname]);

  return (
    <>
      <div
        id="page_header"
        className={
          (pathname.split(path)[1] === "" || pathname.split(path)[1] === "/") &&
          !scrollHeader &&
          !isOpenMenu
            ? style.header
            : style.header
        }
      >
        {!isMobile && !isTablet ? (
          <div className={style.header_wrap}>
            <div className={style.header_container}>
              <Link to={`${process.env.REACT_APP_CLIENT_URL}`}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/common/logo.webp"
                  }
                  alt="logo"
                />
              </Link>

              <div className={style.header_menu_wrap}>
                <div
                  className={
                    "space" === menuType && isOpenMenu
                      ? `${style.header_menu_btn} ${style.active}`
                      : `${style.header_menu_btn}`
                  }
                  onClick={() => handleMenuClick("space")}
                >
                  <span>Smart Space</span>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/common/drop_down.webp"
                    }
                    alt="drop_down"
                  />
                </div>

                <div
                  className={
                    "device" === menuType && isOpenMenu
                      ? `${style.header_menu_btn} ${style.active}`
                      : `${style.header_menu_btn}`
                  }
                  onClick={() => handleMenuClick("device")}
                >
                  <span>Smart Device</span>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/common/drop_down.webp"
                    }
                    alt="drop_down"
                  />
                </div>
                <div
                  className={
                    "solution" === menuType && isOpenMenu
                      ? `${style.header_menu_btn} ${style.active}`
                      : `${style.header_menu_btn}`
                  }
                  onClick={() => handleMenuClick("solution")}
                >
                  <span>Smart Solution</span>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/common/drop_down.webp"
                    }
                    alt="drop_down"
                  />
                </div>
                {/* <div className={style.header_menu_btn}>
                  <span>Infra</span>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/common/drop_down.webp"
                    }
                    alt="drop_down"
                  />
                </div>
                <div className={style.header_group}>
                  <div className={style.header_menu_btn}>
                    <span>조달 등록 제품</span>
                    <img
                      src={
                        `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/common/drop_down.webp"
                      }
                      alt="drop_down"
                    />
                  </div>
                  <div className={style.header_menu_btn}>
                    <span>리브테크놀로지</span>
                    <img
                      src={
                        `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/common/drop_down.webp"
                      }
                      alt="drop_down"
                    />
                  </div>
                </div> */}
              </div>
            </div>

            <div
              className={style.sub_header}
              style={
                isOpenMenu
                  ? { opacity: 1, zIndex: 10, pointerEvents: "auto" }
                  : { opacity: 0, zIndex: -10, pointerEvents: "none" }
              }
            >
              <div className={style.sub_header_body}>
                {menuSwitch(menuType)}
              </div>
              <div className={style.sub_header_footer}>
                <div className={style.sub_header_footer_container}>
                  {/* <button type="button">
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/header/call.png`}
                      alt="call"
                    />
                    <span>고객 상담 문의</span>
                  </button>
                  <span />
                  <button type="button">
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/header/handshake.png`}
                      alt="call"
                    />
                    <span>제휴 / 제안 문의</span>
                  </button>
                  <span /> */}
                  <div className={style.sub_header_info_list}>
                    <div className={style.sub_header_info_item}>
                      <div className={style.sub_header_info_title}>
                        <img
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/call.png`}
                          alt=""
                        />
                        <span>고객 상담 문의</span>
                      </div>
                      <div className={style.sub_header_info_seperate} />
                      <p className={style.sub_header_info_desc}>
                        <a href="tel:070-7798-1311">070-7798-1311</a>
                      </p>
                    </div>
                    <div className={style.sub_header_info_item}>
                      <div className={style.sub_header_info_title}>
                        <img
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/handshake.png`}
                          alt=""
                        />
                        <span>제휴 / 제안 문의</span>
                      </div>
                      <div className={style.sub_header_info_seperate} />
                      <p className={style.sub_header_info_desc}>
                        support@riv-tech.co.kr
                      </p>
                    </div>
                  </div>

                  <button
                    type="button"
                    onClick={handleDownloadIntroduction}
                  >
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/header/download.png`}
                      alt="call"
                    />
                    <span>회사소개서 다운로드</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={style.header_wrap}>
            <div className={style.header_container}>
              <Link to={`${process.env.REACT_APP_CLIENT_URL}`}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/common/logo_m.png"
                  }
                  alt="logo"
                />
              </Link>
              <button
                className={style.header_btn}
                onClick={() => handleMobileMenuOpen()}
              >
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/header/menu.png`}
                  alt="menu"
                />
              </button>
              <div
                className={
                  isOpenMenu
                    ? `${style.mobile_menu_wrap} ${style.on}`
                    : `${style.mobile_menu_wrap}`
                }
              >
                <div
                  className={style.mobile_menu_outer}
                  onClick={() => handleMobileMenuOpen()}
                >
                  <div
                    className={style.mobile_menu_container}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className={style.mobile_menu_header_content}>
                      <button
                        className={style.close_menu_btn}
                        onClick={() => handleMobileMenuOpen()}
                      >
                        <img
                          src={`${process.env.REACT_APP_CLIENT_URL}img/common/close.webp`}
                          alt="menu"
                        />
                      </button>
                    </div>
                    {/* body */}
                    <section className={style.menu_body_content}>
                      <ul className={style.menu_list}>
                        <MobileMenuItem
                          title="Smart Space"
                          child={<MobileSmartSpace />}
                          menuType={openMenuType}
                          setMenuType={setOpenMenuType}
                        />
                        <MobileMenuItem
                          title="Smart Device"
                          child={<MobileSmartDevice />}
                          menuType={openMenuType}
                          setMenuType={setOpenMenuType}
                        />
                        <MobileMenuItem
                          title="Smart Solution"
                          child={<MobileSmartSolution />}
                          menuType={openMenuType}
                          setMenuType={setOpenMenuType}
                        />
                      </ul>
                    </section>
                    {/* footer */}
                    <section className={style.menu_footer_content}>
                      <button
                        className={style.company_intro_btn}
                        onClick={handleDownloadIntroduction}
                      >
                        <img
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/icon_riv.png`}
                          alt=""
                        />
                        <p>회사소개서 다운로드</p>
                        <img
                          src={`${process.env.REACT_APP_CLIENT_URL}img/header/download.png`}
                          alt=""
                        />
                      </button>
                      <div className={style.footer_company_info}>
                        <div className={style.footer_company_info_title}>
                          <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/call.png`}
                            alt=""
                          />
                          <p>고객 상담 및 제휴/제안 문의</p>
                        </div>
                        <ul className={style.footer_company_info_list}>
                          <li className={style.footer_company_info_item}>
                            <p>Tel.</p>
                            <a href="tel:070-7798-1311">070 - 7798 - 1311</a>
                          </li>
                          <li className={style.footer_company_info_item}>
                            <p>E-mail.</p>
                            <p>support@riv-tech.co.kr</p>
                          </li>
                        </ul>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Header;
